import React, { PropTypes, Component } from 'react'
import styled from 'styled-components'
import R from 'ramda'
import Table from '../../components/Table'
import { sortArray, isUserFavorite } from '../../Utils'
import { findProperties } from '../../sources/SearchSource'
import { Metrics } from '../../Themes'
import Key from '../../svg-icons/Key'
import { defaultLimit } from '../../Utils/Constants'
import { fromJS } from 'immutable'
import { tableKeysDefault } from '../../Utils/Defaults'

const Container = styled.section`
  height: calc(
    100vh - (${Metrics.components.navbarDefault} +
          ${Metrics.components.searchbar})
  );
  margin-top: calc(${Metrics.components.searchbar} - 1px);
  button {
    margin-top: ${Metrics.margins.base};
  }
  position: relative;

  @media screen and (max-width: ${Metrics.breakpoints.tablet}) {
    margin-top: 0;
  }
`

class PropertiesList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      properties: [],
      counter: 0,
      isFetching: false,
      canLoadMore: true,
      keys: R.prepend(
        {
          title: 'Favorite',
          key: 'favorite',
          accessor: d => {
            return isUserFavorite(this.props.user, d) ? (
              <Key />
            ) : (
              <Key className='notFavorite' />
            )
          },
          sortAccessor: d => isUserFavorite(this.props.user, d),
          width: 80,
          sort: null
        },
        R.clone(tableKeysDefault)
      )
    }
    this.searchProperties = this.searchProperties.bind(this)
    this.propertyDetail = this.propertyDetail.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
    this.handleSort = this.handleSort.bind(this)
    this.loadMoreProperties = this.loadMoreProperties.bind(this)
  }

  componentWillReceiveProps (nextProps) {
    if (!fromJS(this.props.settings).equals(fromJS(nextProps.settings))) {
      this.searchProperties(nextProps.settings)
    }
  }

  componentWillMount () {
    this.searchProperties(this.props.settings)
    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateDimensions)
  }

  updateDimensions () {
    this.forceUpdate()
  }

  searchProperties (settings) {
    this.setState({ isFetching: true }, () => {
      let query = Object.assign({}, settings, { published: true, sold: false })
      findProperties({ settings: query, skip: 0, limit: defaultLimit })
        .then(response => {
          const { results = [], noResults } = response.data
          this.setState({
            properties: results,
            counter: results.length,
            isFetching: false,
            canLoadMore: results.length < noResults
          })
        })
        .catch(console.error)
    })
  }

  loadMoreProperties () {
    const { counter, properties, canLoadMore } = this.state
    const { settings } = this.props
    let query = Object.assign({}, settings, { published: true, sold: false })
    if (canLoadMore) {
      this.setState({ isFetching: true }, () => {
        findProperties({ settings: query, skip: counter, limit: defaultLimit })
          .then(response => {
            const { results = [], noResults } = response.data
            const newList = R.union(properties, results)
            this.setState({
              properties: newList,
              counter: newList.length,
              isFetching: false,
              canLoadMore: newList.length < noResults
            })
          })
          .catch(console.error)
      })
    }
  }

  handleSort (el) {
    const keys = R.clone(this.state.tableHeaderKeys)
    const keyIndex = R.findIndex(R.propEq('title', el.title), keys)
    const result = sortArray(el, this.state.properties)
    keys.forEach(el => {
      el.sort = null
    })
    keys[keyIndex] = result.sortKey
    this.setState({ properties: result.list, tableHeaderKeys: keys })
  }

  propertyDetail (id) {
    const { router } = this.props
    router.push('/property/' + id)
  }

  render () {
    const width = window.screen.availWidth
    const height =
      document.getElementById('propertyList') &&
      document.getElementById('propertyList').offsetHeight
    return (
      <Container id={'propertyList'}>
        <Table
          keys={this.state.keys}
          data={this.state.properties}
          isFetching={this.state.isFetching}
          rowClick={this.propertyDetail}
          loadMore={this.loadMoreProperties}
          width={width}
          height={height}
          handleSort={this.handleSort}
          canLoadMore={this.state.canLoadMore}
        />
      </Container>
    )
  }
}

PropertiesList.propTypes = {
  settings: PropTypes.object,
  router: PropTypes.object,
  user: PropTypes.object
}

export default PropertiesList



// WEBPACK FOOTER //
// ./src/pages/Search/PropertiesList.js